// Sol & Jade - base.js (Worker A: reveal observer, header scroll state, mobile drawer)
document.addEventListener('DOMContentLoaded', function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  var revealEls = document.querySelectorAll('.sj-reveal');
  if (revealEls.length) {
    if (prefersReducedMotion) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    } else if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { observer.observe(el); });

      /* Backstop: elements already in view before the observer attaches
         (no scroll, bfcache restore, anchor jump) never fire an intersection
         callback. Sweep once on load and again after a short timeout, and
         force-reveal anything still hidden so no section stays blank. */
      var revealAllRemaining = function () {
        revealEls.forEach(function (el) {
          if (!el.classList.contains('is-visible')) {
            el.classList.add('is-visible');
            observer.unobserve(el);
          }
        });
      };
      var sweepViewport = function () {
        window.requestAnimationFrame(function () {
          revealEls.forEach(function (el) {
            if (el.classList.contains('is-visible')) return;
            var rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
              el.classList.add('is-visible');
              observer.unobserve(el);
            }
          });
        });
      };
      sweepViewport();
      window.addEventListener('load', sweepViewport);
      window.setTimeout(revealAllRemaining, 1500);
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* Header scroll state */
  var header = document.querySelector('.sj-header');
  if (header && !header.classList.contains('sj-header--solid')) {
    var onScroll = function () {
      if (window.scrollY > 8) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Home header logo over hero: hidden while the hero is on screen, fades
     in once the visitor scrolls past it. Scoped to the home template via
     .sj-home (set on <html> from the head script, so nothing changes on
     product/collection/page/cart headers). */
  var homeHero = document.querySelector('.sj-home .sj-hero');
  var homeHeaderLogo = document.querySelector('.sj-header__logo');
  if (homeHero && homeHeaderLogo) {
    if ('IntersectionObserver' in window) {
      /* rootMargin only accepts px/percent, so measure the header in
         pixels rather than reading the --header-h rem custom property. */
      var headerHeightPx = header ? Math.round(header.getBoundingClientRect().height) : 0;
      var heroLogoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            homeHeaderLogo.classList.remove('is-header-logo-visible');
          } else {
            homeHeaderLogo.classList.add('is-header-logo-visible');
          }
        });
      }, { threshold: 0.12, rootMargin: '-' + headerHeightPx + 'px 0px 0px 0px' });
      heroLogoObserver.observe(homeHero);
    } else {
      /* No IntersectionObserver support: keep the logo visible rather
         than stuck hidden. */
      homeHeaderLogo.classList.add('is-header-logo-visible');
    }
  }

  /* Mobile drawer */
  var burger = document.querySelector('[data-drawer-open]');
  var closeBtn = document.querySelector('[data-drawer-close]');
  var drawer = document.querySelector('.sj-drawer');

  if (burger && drawer) {
    var lastFocused = null;

    var focusableSelector = 'a[href], button:not([disabled])';

    var trapFocus = function (e) {
      if (e.key !== 'Tab') return;
      var focusable = drawer.querySelectorAll(focusableSelector);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    var openDrawer = function () {
      lastFocused = document.activeElement;
      drawer.removeAttribute('inert');
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var firstFocusable = drawer.querySelector(focusableSelector);
      if (firstFocusable) firstFocusable.focus();
      document.addEventListener('keydown', onKeydown);
    };

    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    };

    var onKeydown = function (e) {
      if (e.key === 'Escape') {
        closeDrawer();
      } else {
        trapFocus(e);
      }
    };

    burger.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  }

  /* Experience carousel: CSS scroll-snap is the carousel, JS only adds controls.
     No autoplay. Do not add a timer, an auto-advance, or pause-on-hover here. */
  document.querySelectorAll('[data-sj-carousel-rail]').forEach(function (rail) {
    var section = rail.closest('.sj-carousel');
    if (!section) return;
    var controls = section.querySelector('[data-sj-carousel-controls]');
    var prevBtn = section.querySelector('[data-sj-carousel-prev]');
    var nextBtn = section.querySelector('[data-sj-carousel-next]');
    var thumb = section.querySelector('[data-sj-carousel-thumb]');
    var progress = section.querySelector('[data-sj-carousel-progress]');

    if (controls) controls.removeAttribute('hidden');
    if (progress) progress.removeAttribute('hidden');

    var step = function () {
      var first = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).gap) || 0;
      var width = first ? first.getBoundingClientRect().width : rail.clientWidth;
      return width + gap;
    };

    var updateArrows = function () {
      if (!prevBtn || !nextBtn) return;
      var atStart = rail.scrollLeft <= 2;
      var atEnd = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    };

    var ticking = false;
    var updateThumb = function () {
      if (!thumb || !progress) return;
      var trackWidth = progress.clientWidth;
      var thumbWidth = (rail.clientWidth / rail.scrollWidth) * trackWidth;
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      var ratio = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
      var maxTranslate = trackWidth - thumbWidth;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (ratio * maxTranslate) + 'px)';
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateThumb();
        updateArrows();
        ticking = false;
      });
    };

    rail.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateThumb();
    updateArrows();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      });
    }
  });
});
